import { TermPinModel } from '../models/term_pin_model';
import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TermPinServant } from '../servants/term_pin_servant';

export type SaveTermPinCommand = (termId: number) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'saveTermPinCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngTermPinModel: TermPinModel,
      log: any,
      ngTermPinServant: TermPinServant
    ): ICommand => {
      return defineCommandORM('saveTermPinCommand', (deferred: ng.IDeferred<IQuery[]>, termId: number) => {
        const shouldSaveTermPin = ngTermPinServant.isTermPinFeatureEnabled() && ngTermPinServant.shouldUpdateTermPin();
        if (shouldSaveTermPin) {
          const { isPinUpdated, term_pin, updatedTermPin } = ngTermPinModel.read();
          const newTermPin = isPinUpdated ? updatedTermPin : term_pin;
          $http
            .post(`/reg/termpin/term/${termId}/`, { term_pin: newTermPin })
            .then((response: ng.IHttpPromiseCallbackArg<any>) => {
              deferred.resolve();
            })
            .catch((e) => {
              log.issue(`Failed to save the Term PIN`);
              deferred.reject(e);
            });
        } else {
          deferred.resolve();
        }
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/term_pin/commands/save_term_pin_command.ts